import { render } from "./PeerAvatar.vue?vue&type=template&id=78085698"
import script from "./PeerAvatar.vue?vue&type=script&lang=js"
export * from "./PeerAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__